export default __webpack_public_path__ + "static/media/hide.776bcd8c.svg";